

// Products Action Types
export const InsertProductAction="InsertProducts";
export const ProductDetailsAction="ProductDetails";
export const AddToCartAction="AddToCart";
export const OpenModalAction="OpenModal";
export const CloseModalAction="CloseModal";

// Cart Action Types
export const UpdateCartAction="UpdateCartAction";
export const IncrementCountAction="IncrementProductCount";
export const DecrementCountAction="DecrementProductCount";
export const RemoveProductAction="RemoveProductAction";
export const ClearCartAction="ClearCart";
export const ClearCartAmountAction="ClearCartPreviousAmount";

